import { useDispatch, useSelector } from "react-redux";
import { gray650, gray900 } from "../../uiKit/assets/colors/colors";
import Title from "../../uiKit/Title/Title";
import { useHistory, useParams } from "react-router-dom";
import { getJob } from "../../redux/state/jobSlice";
import { useEffect } from "react";
import moment from "moment";
import AnimatedLoading from "../../uiKit/Loading/animatedLoading";
import Mail from "../../uiKit/assets/svg/phone.svg";
import Phone from "../../uiKit/assets/svg/mail.svg";

const ViewJob = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();

  const job = useSelector((state) => state.job.job);
  const isLoading = useSelector((state) => state.job.isLoading);

  useEffect(() => {
    if (!id) return;
    dispatch(getJob(id));
  }, [dispatch, id]);

  if (!job) return <></>;

  return (
    <>
      <div className="breadcrumbWrapper">
        <Title text="Jobs" fontWeight={500} color={gray650} onClick={() => history.push("/jobs")} />
        <Title text=">" fontWeight={500} color={gray650} />
        <Title text={job.title} color={gray900} fontWeight={500} />
      </div>
      <div className="jobExtendedWrapper">
        <Title
          text={moment([3, 4].includes(job.status.status) ? job.publishedAt : job.createdAt).format(
            "MM/DD/YYYY h:mm A"
          )}
          fontSize={12}
          lineHeight={14}
          fontWeight={400}
          color={gray650}
        />
        <div className="jobTitle">
          <Title text={job.title} fontSize={16} fontWeight={600} />
          <Title
            text={`by ${job.contactPerson}`}
            lineHeight={14}
            fontSize={12}
            fontWeight={400}
            color={gray650}
          />
        </div>
        <div className="jobDetails">
          <div style={{ display: "flex", alignItems: "center" }}>
            <Title text={`$${job.compensation}`} fontWeight={600} fontSize={14} />
            <Title text="/month" fontWeight={400} fontSize={14} />
          </div>
          <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "4px" }}>
            {!!job.location && (
              <Title
                className={"jobChips"}
                text={job.location}
                fontWeight={400}
                lineHeight={14}
                fontSize={12}
              />
            )}
            <Title
              className={"jobChips"}
              text={job.employmentType.name}
              fontWeight={400}
              lineHeight={14}
              fontSize={12}
            />
          </div>
        </div>

        {job.description && <Title text={job.description} fontSize={14} fontWeight={400} />}

        <div className="contact">
          <Title text="Apply for a job:" fontWeight={600} fontSize={14} />
          <div className="info">
            <img alt="phone" src={Phone} />
            <Title text={job.phoneNumber} fontWeight={600} fontSize={14} />
          </div>
          <div className="info">
            <img alt="mail" src={Mail} />
            <Title text={job.email} fontWeight={600} fontSize={14} />
          </div>
        </div>
        <AnimatedLoading loading={isLoading} width="100%" />
      </div>
    </>
  );
};

export default ViewJob;
